/**
 * User-facing copy for catch-up / summarize generate failures.
 */

export const CATCHUP_RATE_LIMIT_MESSAGE =
  "You’re generating summaries a bit too quickly. Please wait a minute and try again.";

function rawApiMessage(err) {
  const apiMsg = err?.response?.data?.message;
  if (typeof apiMsg === "string" && apiMsg.trim()) return apiMsg.trim();
  if (Array.isArray(apiMsg) && apiMsg.length) {
    return apiMsg.map(String).join(", ");
  }
  return null;
}

function looksLikeThrottleMessage(msg) {
  if (!msg || typeof msg !== "string") return false;
  const lower = msg.toLowerCase();
  return (
    lower.includes("throttlerexception") ||
    lower.includes("too many requests") ||
    lower.includes("rate limit")
  );
}

/**
 * Prefer a calm, actionable message over Nest's raw ThrottlerException text.
 */
export function messageForCatchupGenerateError(
  err,
  { fallback = "Failed to generate summary." } = {}
) {
  const status = err?.response?.status;
  if (status === 429 || looksLikeThrottleMessage(rawApiMessage(err))) {
    return CATCHUP_RATE_LIMIT_MESSAGE;
  }
  if (status === 503) {
    return (
      rawApiMessage(err) ||
      "AI summarize is unavailable right now. Please try again later."
    );
  }
  const raw = rawApiMessage(err);
  if (raw && !looksLikeThrottleMessage(raw)) return raw;
  return fallback;
}
